import { Classes } from '@blueprintjs/core';
import * as React from 'react';
import { Dialog } from 'vet-bones/components';

import { projectsActionCreators } from 'src/actions/projects/actionCreators';
import { DialogConnectionTile } from 'src/components/DialogConnectionTile';
import { TEST_IDS } from 'src/constants/testIds';
import { connectionSelector } from 'src/selectors/connection';
import { AppDispatch } from 'src/store/store';
import * as copy from 'src/templates/copy';
import { useDefaultPortalConnection } from 'src/utils/hooks/useDefaultPortalConnection';
import { useIsMounted } from 'src/utils/hooks/useIsMounted';
import { usePortalConnectionsWithDemo } from 'src/utils/hooks/usePortalConnectionsWithDemo';
import { useReduxDispatch } from 'src/utils/hooks/useReduxDispatch';
import { useReduxSelector } from 'src/utils/hooks/useReduxSelector';
import { useRouterParams } from 'src/utils/hooks/useRouterParams';
import { redirectToPortalDashboard } from 'src/utils/redirectToPortalDashboard';

const updateProjectConnectionDispatcher =
  (projectId: string, connectionId: string) =>
  async (dispatch: AppDispatch) => {
    dispatch(
      projectsActionCreators.updatedProjectConnectionId(projectId, connectionId)
    );
  };

export const ProjectEndpointDialog: React.VFC = () => {
  const isMounted = useIsMounted();
  const { projectId } = useRouterParams();
  const connection = useReduxSelector(connectionSelector);
  const defaultConnection = useDefaultPortalConnection();
  const portalConnections = usePortalConnectionsWithDemo();
  const dispatch = useReduxDispatch();
  const handleProceedWithConnection = async () => {
    if (!connection || !defaultConnection) {
      return;
    }

    const portalConnection = portalConnections?.find(
      (portalConnection) => portalConnection.id === connection.id
    );

    if (!portalConnection) {
      return;
    }

    await dispatch(updateProjectConnectionDispatcher(projectId, connection.id));

    if (isMounted.current) {
      redirectToPortalDashboard(defaultConnection, portalConnection);
    }
  };

  return (
    <Dialog
      autoFocus={false}
      canEscapeKeyClose={false}
      canOutsideClickClose={false}
      className="sd-dialog-project-endpoint"
      enforceFocus={false}
      isCloseButtonShown={false}
      isOpen
      lazy={false}
      title={copy.components.projectEndpointDialog.title}
    >
      <div className={Classes.DIALOG_BODY}>
        <div className="sd-dialog-project-endpoint__tile-wrapper">
          <DialogConnectionTile
            cardClassName="sd-dialog-project-endpoint__tile"
            handleProceedWithConnection={handleProceedWithConnection}
            proceedButtonTestId={TEST_IDS.projectEndpointDialog.proceedButton}
            switchConnectionTestId={
              TEST_IDS.projectEndpointDialog.switchConnection
            }
          />
        </div>
      </div>
    </Dialog>
  );
};
